import {apiAxios as axios} from '../api/axios';
import {Card} from "./cardInterface";

export function deleteCard(deleteCard:Card){
    return axios.delete('/cards/'+ deleteCard.id)
}